export const getPersonInitials = (name: string): string => {
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

export const getPersonStatus = (status: string, busy: boolean) => {
  if (status !== 'active') return { 
    color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400', 
    text: 'Inactive', 
    dot: 'bg-red-400' 
  };
  if (busy) return { 
    color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400', 
    text: 'Busy', 
    dot: 'bg-yellow-400' 
  };
  return { 
    color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400', 
    text: 'Available', 
    dot: 'bg-green-400' 
  };
};

export const extractJobInfo = (skills: string[]) => {
  const department = skills?.find(skill => 
    ['Engineering', 'Design', 'Product', 'Marketing', 'Sales'].includes(skill)
  ) || 'Engineering';
  
  const role = skills?.find(skill => 
    skill.includes('Developer') || skill.includes('Designer') || skill.includes('Manager')
  ) || 'Developer';

  return { role, department };
};

export function replaceZIndex(styleString: string, newZIndex: number) {
  const styleParts = styleString.split(';').map(part => part.trim()).filter(Boolean);

  const updatedParts = styleParts.map(part => {
    if (part.startsWith('z-index')) {
      return `z-index: ${newZIndex}`;
    }
    return part;
  });

  // If z-index was not found, add it
  const hasZIndex = styleParts.some(part => part.startsWith('z-index'));
  if (!hasZIndex) {
    updatedParts.push(`z-index: ${newZIndex}`);
  }

  return updatedParts.join('; ') + ';';
}

export const replaceZIndexStyle = (el: HTMLElement, zIndex: number) => {
  if(!el) return;

  const oldStyleResources = el.getAttribute("style")
  const newStyleResources = replaceZIndex(oldStyleResources!, zIndex)
  el.setAttribute("style", newStyleResources);
}
